module.exports = __webpack_public_path__ + "static/GlitchlessSonyax50-e476fd79bc91658d5f1a5a733749280f.png";